/* eslint-disable */
import React, { useRef } from 'react';
import closeSvg from 'src/assets/close.svg';
import ReactModal from 'react-modal';
import { CloseIcon, Row, Label, Value, ValueGroup, Container, TitleValue, Heading, Separator } from './styles';

const formatDate = (date?: string | Date) => {
  if (!date) return '-';
  return new Date(date).toLocaleDateString('en-US');
};

const getChangedFields = (before: any = {}, after: any = {}) => {
  const changes: Array<{
    field: string;
    before: any;
    after: any;
  }> = [];

  Object.keys(after).forEach(key => {
    if (before[key] !== after[key]) {
      changes.push({
        field: key,
        before: before[key],
        after: after[key],
      });
    }
  });

  return changes;
};

export const InvoiceHistoryModal: React.FC<{
  isOpen: boolean;
  setIsOpen: Function;
  data: any; // optional because first time it's null
}> = ({ isOpen, setIsOpen, data = null }) => {
  const modalRef = useRef(null);

  const handleModalClose = () => {
    setIsOpen(false);
  };

  if (data) {
    console.log(data);
  }

  return (
    <ReactModal
      isOpen={isOpen}
      ariaHideApp={false}
      style={{
        overlay: {
          overflowX: 'auto',
          margin: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
        content: {
          borderRadius: '30px',
          margin: '0px auto',
          width: 'max-content',
          minWidth: '550px',
          maxWidth: '720px',
          height: 'max-content',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        },
      }}
      onRequestClose={handleModalClose}
      // eslint-disable-next-line no-return-assign
      contentRef={(node: any) => (modalRef.current = node)}
    >
      <CloseIcon src={closeSvg} onClick={handleModalClose} />
      {/* <SecurityQuesForm username={username} onSuccess={handleModalClose} /> */}

      <>
        {/* {data?.actionType === 'Submitted' ? ( */}
        {data?.actionType === 'CREATED' ? (
          <Container>
            {/* Assignment */}
            <Heading>Details</Heading>
            <Separator />
            <Row>
              <Label>Assignment</Label>
              <ValueGroup>
                <Value>Assignment ID - {data.invoice?.assignmentId}</Value>
                <Value>Job Title - {data.invoice?.jobTitle}</Value>
                <Value>Hire Type - {data.invoice?.hireType}</Value>
              </ValueGroup>
            </Row>
            {/* Company */}
            <Row>
              <Label>Company</Label>
              <ValueGroup>
                <Value>{data.invoice?.companyName}</Value>
              </ValueGroup>
            </Row>

            {/* Client */}
            <Row>
              <Label>Client</Label>
              <ValueGroup>
                <Value>{data.invoice?.clientName}</Value>
              </ValueGroup>
            </Row>

            {/* Worker */}
            <Row>
              <Label>Worker</Label>
              <ValueGroup>
                <Value>{data.invoice?.employeeName}</Value>
              </ValueGroup>
            </Row>

            {/* Approvers */}
            <Row>
              <Label>Approvers</Label>
              <ValueGroup>
                <Value>{data?.invoice?.approverName}</Value>
                <Value>{data?.invoice?.coApproverName}</Value>
              </ValueGroup>
            </Row>

            {/* Amounts */}
            <Row>
              <Label>Amounts</Label>
              <ValueGroup>
                <Value>Billable Amount - ${data?.invoice?.billableAmount}</Value>
                <Value>Payable Amount - ${data?.invoice?.payableAmount}</Value>
                <Value>Submitted Amount - ${data?.invoice?.submittedAmount}</Value>
                <Value>Total Hours - {data?.invoice?.totalHours}</Value>
              </ValueGroup>
            </Row>

            {/* Rate Info */}
            <Row>
              <Label>Rate Info</Label>
              <ValueGroup>
                <Value>Effective Date - {data?.invoice?.effectiveDate}</Value>

                <TitleValue>Standard</TitleValue>
                <Value>Bill Rate - ${data?.invoice?.billRate}</Value>
                <Value>Pay Rate - ${data?.invoice?.payRate}</Value>
                <Value>Markup - {data?.invoice?.rateMarkup}%</Value>

                <TitleValue>Overtime</TitleValue>
                <Value>Bill Rate - ${data?.invoice?.overtimeBillRate}</Value>
                <Value>Pay Rate - ${data?.invoice?.overtimePayRate}</Value>
                <Value>Markup - {data?.invoice?.overtimeMarkup}%</Value>
              </ValueGroup>
            </Row>

            {/* Invoice Dates */}
            <Row>
              <Label>Invoice Start Date</Label>
              <ValueGroup>
                <Value>{data?.invoice?.periodStart}</Value>
              </ValueGroup>
            </Row>

            <Row>
              <Label>Invoice End Date</Label>
              <ValueGroup>
                <Value>{data?.invoice?.periodEnd}</Value>
              </ValueGroup>
            </Row>

            <Row>
              <Label>Invoice Date</Label>
              <ValueGroup>
                <Value>{data?.invoice?.invoiceDate}</Value>
                <Value>{data?.invoice?.invoiceDate}</Value>
              </ValueGroup>
            </Row>

            {/* Attachments */}
            <Row>
              <Label>Attachments</Label>
              <ValueGroup>
                {data?.invoice?.attachments?.map((attachment: any) => (
                  <Value key={attachment.id}>{attachment.attachmentName}</Value>
                ))}
              </ValueGroup>
            </Row>

            <Row>
              <Label>Version</Label>
              <ValueGroup>
                <Value>{data?.invoice?.version}</Value>
              </ValueGroup>
            </Row>

            <Row>
              <Label>Status</Label>
              <ValueGroup>
                <Value>{data?.invoice?.status}</Value>
              </ValueGroup>
            </Row>

            <Row>
              <Label>Submitted At</Label>
              <ValueGroup>
                <Value>{formatDate(data?.invoice?.createdAt)}</Value>
              </ValueGroup>
            </Row>
          </Container>
        ) : (
          <Container>
            <Heading>Details</Heading>
            <Separator />

            <Heading>From</Heading>

            {getChangedFields(data?.details?.before, data?.details?.after).map(change => (
              <Row key={change.field}>
                <Label>{change.field}</Label>
                <ValueGroup>
                  <Value>{String(change.before ?? '-')}</Value>
                </ValueGroup>
              </Row>
            ))}

            <Separator />

            <Heading>To</Heading>

            {getChangedFields(data?.details?.before, data?.details?.after).map(change => (
              <Row key={change.field}>
                <Label>{change.field}</Label>
                <ValueGroup>
                  <Value>{String(change.after ?? '-')}</Value>
                </ValueGroup>
              </Row>
            ))}

            {data?.details?.comment && (
              <>
                <Separator />
                <Row>
                  <Label>Comment</Label>
                  <ValueGroup>
                    <Value>{data.details.comment}</Value>
                  </ValueGroup>
                </Row>
              </>
            )}
          </Container>
        )}
      </>
    </ReactModal>
  );
};
